import { useState } from 'react';
import type { ViewOptionsType } from '../ui/show-menu-item/view-options/types.tsx';
import { ViewOptions } from '../ui/show-menu-item/view-options/constants.tsx';
import messages from '../ui/show-menu-item/messages.tsx';

export const useViewOptions = () => {
	// TODO remove the mock implementation, add Context + Provider and connect the logic with BE
	const [currentViewOption, setCurrentViewOption] = useState<ViewOptionsType>(
		ViewOptions.STARRED_AND_RECENT,
	);

	const viewOptionsList = [
		{
			label: messages.starredAndRecentProjectsLabel,
			value: ViewOptions.STARRED_AND_RECENT,
		},
		{
			label: messages.starredProjectsLabel,
			value: ViewOptions.STARRED,
		},
	];

	return {
		viewOptionsList,
		selectedViewOption: currentViewOption,
		setSelectedViewOption: setCurrentViewOption,
	};
};
